import { useSelector } from 'react-redux';
import { selectIsDisableAi } from '../../reducers/userInfoReducer';
import useAgentsSubscriptions from './useAgentsSubscriptions';
import { AgentType } from '@server/ai';

const useIsAgentEnabled = (agentType: AgentType) => {
  const isDisableAi = useSelector(selectIsDisableAi);
  const agentsSubscriptions = useAgentsSubscriptions();
  const isAgentEnabled = agentsSubscriptions[agentType];

  return !isDisableAi && isAgentEnabled;
};

export default useIsAgentEnabled;
